import React from 'react';

export default function({children, center, light, inline}){
    
    return <h2 className={`mb-5 text-2xl md:text-3xl tracking-[-0.05em] ${light ? 'text-[#e1deb1]' : 'text-dark-purple'} ${center ? 'text-center': <></>} ${inline ? 'inline': <></>}`}>{children}</h2>;

}